export const coreConfig = [
  {
    img: require('./images/jz1.png'),
    title: '全域覆盖',
    detail: '实现境内（不含港澳台）核心资产全图谱协查，确保法律效力权威性。',
  },
  {
    img: require('./images/jz2.png'),
    title: '全景洞察',
    detail: '全结构化输出权利凭证号、权利限制状态（查封/抵押）、使用期限等核心字段，赋能案件办理多维取证。',
  },
  {
    img: require('./images/jz3.png'),
    title: '数据权威',
    detail: '接入权威数据源，支持毫秒级实时同步，确保信息精确可靠',
  },
  {
    img: require('./images/jz4.png'),
    title: '极速响应',
    detail: '标准化查询T+3工作日反馈，助力办案效率提升。',
  },
];

export const applyConfig = [
  {
    img: require('./images/bz1.png'),
    title: '析产诉讼',
    detail: '应对遗产继承、合伙解体、共有物分割等多类型析产纠纷，一键调取涉案方案全国核心资产全量清单破解“财产线索举证困难”。',
  },
  {
    img: require('./images/bz2.png'),
    title: '执行攻坚',
    detail: '覆盖执行立案、终本激活全周期场景，实时监控被执行人及其关联网络（含亲属、商业伙伴、影子公司）名下核心资产异动。',
  },
  {
    img: require('./images/bz4.png'),
    title: '不良资产',
    detail: '金融机构不良资产处置方案，打破区域数据孤岛，实现全链条穿透式追踪，显著降低跨域作业成本，助力律所精准锁定高价值资产。',
  },
];

export const cooConfig = [
  {
    img: require('./images/lc1.png'),
    title: '01协议签署',
  },
  {
    img: require('./images/lc3.png'),
    title: '02身份核验',
  },
  {
    img: require('./images/lc2.png'),
    title: '03申请提报',
  },
  {
    img: require('./images/lc4.png'),
    title: '04资料审验',
  },
  {
    img: require('./images/lc5.png'),
    title: '05结果交付',
  },
];

export default {};
